import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueFormDescription', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_forms/fragments/description/issue_form_description.html'),
        controller: 'IssueFormDescriptionController',
        controllerAs: 'IssueFormDescriptionCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            description: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/description/issue_form_description.component.ts